import { useSettings } from '@/config/settings';

export const getUrl = (path: string) => {
  const { settings } = useSettings();
  return `${settings.host}${path}`;
};
